import ApiConfig from "../config/ApiConfig";

/**
 * Fetches the property type from the backend based on the address
 * @param {string} street - Street number and name (e.g., "123 Main St")
 * @param {string} zip - Zip code (e.g., "63117")
 * @returns {Promise<string|null>} - Property type or null if not found
 */
export default async function getPropertyType(street, zip) {
  if (!street || !zip) {
    console.warn(
      "Missing required address parameters for property type lookup"
    );
    return null;
  }

  try {
    const propertyTypeUrl = new URL(
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.propertyTypeEndpoint
    );

    propertyTypeUrl.searchParams.set("address1", street);
    propertyTypeUrl.searchParams.set("address2", zip);

    const response = await fetch(propertyTypeUrl);

    if (!response.ok) {
      console.error(`Property type lookup failed: ${response.status}`);
      return null;
    }

    const data = await response.json();
    return data.propertyType || null;
  } catch (error) {
    console.error("Error fetching property type:", error);
    return null;
  }
}
